// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e304bd22","578":"3e7f1d90"}[chunkId] + ".chunk.js";
};